import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { Mail01 } from "@untitledui/icons";

const faqItems = [
  {
    question: "Who is My Garage for?",
    answer:
      "My Garage is built for independent mechanics, auto repair shops, and garage businesses of any size. Whether you're a one-person shop or a multi-bay operation, the platform scales with you.",
  },
  {
    question: "How long does it take to set up?",
    answer:
      "Most shops are up and running within a day. Add your services and pricing to the catalog, configure storage units if you have them, and start creating jobs immediately.",
  },
  {
    question: "Can I manage multiple technicians?",
    answer:
      "Yes. Add team members to your account and assign jobs to specific technicians. Each job tracks who it's assigned to and its current status.",
  },
  {
    question: "How does inventory tracking work?",
    answer:
      "Add parts to your inventory with quantities, cost price, sell price, and minimum stock levels. When parts are used on a job, stock is tracked and costs flow into the invoice automatically.",
  },
  {
    question: "Do you support storage unit management?",
    answer:
      "Absolutely. Define units by size (S/M/L/XL), set monthly rates, mark climate-controlled options, and manage rental periods with start/end dates and status tracking.",
  },
  {
    question: "Can my customers see their job status?",
    answer:
      "Customer-facing access is on our roadmap. For now, you can keep customers informed through the notes and status updates on each job.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="section-padding">
      <div className="landing-container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="heading-2 text-text-primary mb-4">
            Frequently Asked{" "}
            <span className="text-gradient">Questions</span>
          </h2>
          <p className="subtitle-2">
            Everything you need to know about getting started with My Garage.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-2">
            {faqItems.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-bg-primary border border-border-secondary rounded-lg px-6 overflow-hidden"
              >
                <AccordionTrigger className="text-left text-text-primary font-medium hover:no-underline">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-text-tertiary leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Support CTA */}
          <div className="mt-12 text-center bg-bg-primary border border-border-secondary rounded-xl p-8">
            <div className="w-12 h-12 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail01 className="w-6 h-6 text-brand-600" />
            </div>
            <h3 className="text-lg font-semibold text-text-primary mb-2">
              Have more questions?
            </h3>
            <p className="text-sm text-text-tertiary mb-4">
              Our team is here to help you get started.
            </p>
            <a
              href="mailto:support@mygarage.com"
              className="text-sm font-medium text-brand-600 hover:text-brand-700 transition-colors"
            >
              support@mygarage.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
